<template>
  <div class="b-cart-movie">
    <div class="b-cart-movie__header">
      <div class="b-cart-movie__poster">
        <img :src="selectedMovie.thumb" :alt="selectedMovie.title" />
      </div>
      <div>
        <div class="b-cart-movie__title">{{ selectedMovie.title }}</div>
        <div class="b-cart-movie__sub-title">{{ selectedMovie.subTitle }}</div>
      </div>
    </div>
    <div class="b-cart-movie__date">
      <span>{{ selectedDay.formattedDate }}</span>
      <span v-if="selectedRoom.showtime">
        @ {{ getShowTime(selectedRoom.showtime) }}
      </span>
    </div>
    <div class="b-cart-movie__cinema">{{ selectedCinema.display }}</div>

    <div class="b-cart-movie__footer">
      <div class="b-cart-movie__screen">
        <div class="b-cart-movie__room">
          {{ getRoomType(store.bookingProgress.selectedRoom) }}
        </div>
        <div class="b-cart-movie__poster">{{ selectedRoom.screenName }}</div>
      </div>
      <div class="b-cart-movie__screening-labels">
        <ScreenTypes
          container-class="e-rooms--orange"
          :dolby="selectedRoom.isDolby"
          :three-dimensions="selectedRoom.is3D"
          :imax="selectedRoom.isImax"
          :imax3d="selectedRoom.isImax3D" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useBookingStore } from './../../../store/BookingStore'
import { extractFullTimeFromDate } from './../../../../lib/date'
import ScreenTypes from '../../../components/Shared/ScreenTypes.vue'

const store = useBookingStore()
const { selectedMovie, selectedDay, selectedRoom, selectedCinema } =
  store.bookingProgress

const getShowTime = (date) => {
  return extractFullTimeFromDate(date)
}

const getRoomType = (screen) => {
  return store.getRoomType(screen)
}
</script>
